export class CAlert extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    const variant = this.getAttribute("variant") || "info";
    
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          font-family: sans-serif;
        }

        .alert {
          display: flex;
          align-items: flex-start;
          padding: 12px 16px;
          border-radius: 8px;
          gap: 12px;
          position: relative;
          font-size: 14px;
        }

        .icon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
        }

        .message {
          flex: 1;
        }

        .close {
          background: none;
          border: none;
          cursor: pointer;
          font-size: 16px;
          color: inherit;
        }

        /* Variants */
        .info {
          background-color: #e6f0ff;
          color: #004085;
          border: 1px #00408587 solid;
        }

        .success {
          background-color: #e6ffed;
          color: var(--success);
          border: 1px var(--success) solid;
        }
        .warning {
          background-color: #fff3cd;
          color: #856404;
          border: 1px #85640487 solid
        }

        .error {
          background-color: #f8d7da;
          color: #721c24;
          border: 1px #721c2487 solid
        }

        .neutral {
          background-color: var(--light-blue-100);
          color: #343a40;
          border: 1px #343a4030 solid
        }
      </style>

      <div class="alert ${variant}">
        <slot name="icon" class="icon"></slot>
        <div class="message"><slot></slot></div>
        <button class="close" aria-label="Close" style="display:none;">&times;</button>
      </div>
    `;
  }

  connectedCallback() {
    if (this.hasAttribute("dismissable")) {
      this.shadowRoot.querySelector(".close").style.display = "block";
      this.shadowRoot.querySelector(".close").addEventListener("click", () => {
        this.remove();
      });
    }
  }

  static get observedAttributes() {
    return ["variant"];
  }
}

customElements.define("c-alert", CAlert);